/* External */
import {
  Children, memo, useCallback,
} from 'react';
import PropTypes from 'prop-types';
import { withFocusable } from '@noriginmedia/react-spatial-navigation';

/* Components */
import TabTitle from './TabTitle';

/* Utils */
import { noOp } from '../../utils/functions';

function TabsList({
  activeTab,
  wasViewed,
  realFocusKey,
  handleArrowPress,
  onTabBecameFocused,
  onTabBecameActive,
  onScrolledChange,
  children,
}) {
  const handleTabBecameFocused = useCallback((layout, { tabId }) => {
    onTabBecameFocused(tabId);
  }, [onTabBecameFocused]);

  return (
    <ul className="dtv-html5-c-tabs__list">
      { Children.map(children, ({ props: { 'data-labeltab': labelTab } }, id) => {
        const isSelected = wasViewed && activeTab === id;
        return (
          <TabTitle
            tabId={id}
            label={labelTab}
            focusKey={`${realFocusKey}_${id}`}
            onArrowPress={handleArrowPress}
            onBecameFocused={handleTabBecameFocused}
            onBecameActive={onTabBecameActive}
            onScrolledChange={onScrolledChange}
            isSelected={isSelected}
          />
        );
      })}
    </ul>
  );
}

TabsList.defaultProps = {
  activeTab: undefined,
  wasViewed: false,
  realFocusKey: '',
  handleArrowPress: noOp,
  onTabBecameFocused: noOp,
  onTabBecameActive: noOp,
  onScrolledChange: noOp,
};

TabsList.propTypes = {
  activeTab: PropTypes.number,
  wasViewed: PropTypes.bool,
  realFocusKey: PropTypes.string,
  handleArrowPress: PropTypes.func,
  onTabBecameFocused: PropTypes.func,
  onTabBecameActive: PropTypes.func,
  onScrolledChange: PropTypes.func,
  children: PropTypes.node.isRequired,
};

export default memo(withFocusable()(memo(TabsList)));
